import React from "react";
import {
  Collapse,
  ControlGroup,
  Tag,
  EditableText,
  Card,
  Elevation,
} from "@blueprintjs/core";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import Diagnosis from "./Diagnosis";
import { apiCallPost } from "../../fns/util";
import cogoToast from "cogo-toast";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import ClinicalEntity from "../templates/ClinicalEntity";
import { generateMasterVisitEntities } from "../turbo/masterVisitEntities";

class Analysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      notesText: null,
      notesTouched: false,
      searching: false,
      searchResults: [],
    };

    this.masterVisitEntities = generateMasterVisitEntities(
      this.props.authStore.prefix
    );

    let section_ = null;
    let subsection_ = null;

    for (let section of this.masterVisitEntities) {
      if (section.sectionName !== "EXAMINATION") continue;
      for (let subsection of section.subsections) {
        if (subsection.subsectionName === "OBSERVATIONS") {
          section_ = section;
          subsection_ = subsection;
          break;
        }
      }
    }
    this.section = section_;
    this.subsection = subsection_;
    // let diagnosis = this.props.data.dischargeEntities.filter(
    //   (currentItem) =>
    //     currentItem.sectionName === "EXAMINATION" &&
    //     (currentItem.subsectionName === "OBSERVATIONS" ||
    //       currentItem.subsectionName === "DIAGNOSIS")
    // );
    // if (!diagnosis || !diagnosis.length) {
    //   this.props.setShowDischarge({
    //     showDischarge: true,
    //   });
    // }
  }

  renderNotes = () => {
    return (
      <div
        style={{ textAlign: "left", marginTop: "10px", marginBottom: "10px" }}
      >
        <EditableText
          multiline
          placeholder="You can use this space to keep your notes about the progression of the disease, or anything worth mentioning that you have noticed."
          value={
            this.state.notesTouched
              ? this.state.notesText
              : this.props.dxNotes[0].text
          }
          onChange={(event) =>
            this.setState({ notesText: event, notesTouched: true })
          }
          onConfirm={() =>
            this.props.update(
              "dxNotes",
              this.props.dxNotes[0]._id,
              "text",
              this.state.notesTouched
                ? this.state.notesText
                : this.props.dxNotes[0].text
            )
          }
        />
      </div>
    );
  };
  renderShort = () => {
    if (!this.props.data || !this.props.data.length) {
      return (
        <Tag minimal large>
          No diagnosis added.
        </Tag>
      );
    }
    let dxs = this.props.data.map((each) => each.disease);
    let txt = dxs.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/clinical2/${this.props.authStore.prefix}/canonical-search`,
        { entityType: "SIGNS_AND_DISEASES", prefix: string }
      );

      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.setState({ collapse: !this.state.collapse })}
        >
          Analysis
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <AsyncSelWrap
            placeholder="Symptoms..."
            searching={this.state.searching}
            items={this.state.searchResults.map((each) => {
              return {
                ...each,
                item: each.entityName,
                helper: each.anatomicalPart,
              };
            })}
            selectedItem={null}
            update={(item) => this.search(item)}
            onChange={(item) => {
              this.props.onUpdate({
                dischargeEntities: [
                  ...this.props.data.dischargeEntities,
                  {
                    ...item,
                    sectionName: "EXAMINATION",
                    subsectionName: "OBSERVATIONS",
                  },
                ],
                showDischarge: true,
              });
            }}
          />
        )}{" "}
      </ControlGroup>
    );
  };

  renderDiagnosis = () => {
    let diagnosis = this.props.data.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "EXAMINATION" &&
        (currentItem.subsectionName === "OBSERVATIONS" ||
          currentItem.subsectionName === "DIAGNOSIS")
    );

    if (!diagnosis || !diagnosis.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No diagnosis added.
          </Tag>
        </ControlGroup>
      );
    }

    return diagnosis.map((each, index) => {
      return (
        <ClinicalEntity
          isShortForm={each.isShortForm}
          data={each}
          key={`${index}__${each._id}__${each.updatedAt}`}
          subsection={this.subsection}
          entity={each}
          updateVisitEntity={(item) => {
            console.log(item);
            const idx = this.props.data.dischargeEntities.findIndex(
              (each) => each._id === item._id
            );
            let obj = {
              dischargeEntities: [
                ...this.props.data.dischargeEntities.slice(0, idx),
                item,
                ...this.props.data.dischargeEntities.slice(idx + 1),
              ],
              showDischarge: true,
            };

            this.props.onUpdate(obj);
          }}
          removeVisitEntity={() => {
            const idx = this.props.data.dischargeEntities.findIndex(
              (de) => de._id === each._id
            );
            let obj = {
              dischargeEntities: [
                ...this.props.data.dischargeEntities.slice(0, idx),
                ...this.props.data.dischargeEntities.slice(idx + 1),
              ],
              showDischarge: false,
            };
            this.props.onUpdate(obj);
          }}
        />
        // <Diagnosis
        //   data={each}
        //   update={(dxId, key, value) => {
        //     let meds = diagnosis;
        //     let idx = meds.findIndex((each) => each._id === dxId);
        //     meds[idx][key] = value;

        //     let obj = {
        //       dischargeEntities: [...this.props.data.dischargeEntities, meds],
        //     };

        //     this.props.onUpdate(obj);
        //   }}
        //   remove={(dxId) => {
        //     let dd = this.props.data.dischargeEntities;
        //     let idx = _.findIndex(dd, (each) => each._id === dxId);
        //     dd.splice(idx, 1);
        //     let obj = {
        //       dischargeEntities: [...dd],
        //     };

        //     this.props.onUpdate(obj);
        //   }}
        // />
      );
    });
  };
  render() {
    return (
      <Card
        style={{ padding: "0px", background: "none" }}
        elevation={Elevation.FOUR}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            justifyContent: "left",
            padding: "10px",
          }}
        >
          {this.renderHeading()}
          <Collapse isOpen={this.state.collapse}>
            {this.renderDiagnosis()}
          </Collapse>
        </div>
      </Card>
    );
  }
}

export default inject("authStore")(observer(Analysis));
